import {
    CREATE_INVENTORY,
    DELETE_INVENTORY,
    GET_ALL_INVENTORY,
    GET_ID_INVENTORY,
    SEARCH_INVENTORY,
    UPDATE_INVENTORY,
    ADJUST_STOCK,
    TRANSFER_INVENTORY,
    GET_INVENTORY_TRANSFER_HISTORY
} from '@/types/inventoryTypes';

// Initial state dengan proper structure
const actionTypes = [
    { type: CREATE_INVENTORY, key: 'createInventory' },
    { type: DELETE_INVENTORY, key: 'deleteInventory' },
    { type: GET_ALL_INVENTORY, key: 'getAllInventory' },
    { type: GET_ID_INVENTORY, key: 'getIdInventory' },
    { type: SEARCH_INVENTORY, key: 'searchInventory' },
    { type: UPDATE_INVENTORY, key: 'updateInventory' },
    { type: ADJUST_STOCK, key: 'adjustStock' },
    { type: TRANSFER_INVENTORY, key: 'transferInvetory' },
    { type: GET_INVENTORY_TRANSFER_HISTORY, key: 'getInventoryTransferHistory' }
];

let initialState = actionTypes.reduce((acc, { key }) => {
    acc[key] = false;
    acc[`err${key.charAt(0).toUpperCase() + key.slice(1)}`] = false;
    return acc;
}, {});

const inventorySlice = (state = initialState, action) => {
    const acc = actionTypes.find((item) => item.type === action.type);
    if (!acc) return state;
    return {
        ...state,
        [acc.key]: action?.payload?.data,
        [`err${acc.key.charAt(0).toUpperCase() + acc.key.slice(1)}`]: action?.payload?.errorMessage
    };
};

export default inventorySlice;
